<style lang="scss" src='./News.scss' scoped></style>
<template src="./News.html"></template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
export default {
  name: 'News',
  components: {
    
  },
  data() {
    return ({
      refreshDataInterval: null,
    });
  },
  computed: {
    ...mapState('Messages', ['showNews', 'newsCount', 'newsList']),
  },

  methods: {
    ...mapMutations('Messages', ['setShowNews', 'changeContainer', 'setNewsCount']),
    ...mapActions('Messages', ['apiGetNews', 'apiSetNewsAsSeen', 'apiSetAllSeen']),

    markAllAsRead() {
      this.apiSetAllSeen();
      this.setNewsCount(0);
    },

    markAsRead(id) {
      
    },

    startIntervalToRefreshData() {
      this.refreshDataInterval = window.setInterval(() => {
        this.apiGetNews();
      }, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.apiGetNews();
    this.startIntervalToRefreshData();
  },

  beforeDestroy() {
    window.clearInterval(this.refreshDataInterval);
  },

  };

</script>
